import MapViewItemBase from '../models/MapViewItemBase'

// Whether an item draws a marker on a globe view at all. A delivery pin hangs off that marker,
// so it has to ask the same question: it used to be a child of the DOM marker and inherited the
// answer, and now that pins are their own GL layer the check has to be explicit or a shape-only
// location grows a pin with nothing under it.
export function hasDisplayedMarker(item: MapViewItemBase): boolean {
  const { iconProperties, labelProperties } = item.globeViewItemProperties

  return !!(iconProperties?.isDisplayed || labelProperties?.isDisplayed)
}
